(function () {
  function pad(numero) {
    return String(numero).padStart(2, '0');
  }

  var intervalosCuentaAtrasBannerPromoAnimado = new Map();

  function iniciarCuentaAtrasBannerPromoAnimado(raiz) {
    var contenedores = (raiz || document).querySelectorAll(
      '[data-cuenta-atras-banner-promo-animado]'
    );

    contenedores.forEach(function (el) {
      if (el.dataset.caInitBannerPromoAnimado === 'true') return;

      var fechaFinSegundos = parseInt(el.dataset.fechaFinBannerPromoAnimado, 10);
      if (!fechaFinSegundos) {
        el.remove();
        return;
      }

      var diasEl = el.querySelector('[data-ca-dias-banner-promo-animado]');
      var horasEl = el.querySelector('[data-ca-horas-banner-promo-animado]');
      var minutosEl = el.querySelector('[data-ca-minutos-banner-promo-animado]');
      var segundosEl = el.querySelector('[data-ca-segundos-banner-promo-animado]');

      function tick() {
        var ahoraSegundos = Math.floor(Date.now() / 1000);
        var restante = fechaFinSegundos - ahoraSegundos;

        if (restante <= 0) {
          clearInterval(intervalosCuentaAtrasBannerPromoAnimado.get(el));
          intervalosCuentaAtrasBannerPromoAnimado.delete(el);
          el.remove();
          return;
        }

        var dias = Math.floor(restante / 86400);
        var horas = Math.floor((restante % 86400) / 3600);
        var minutos = Math.floor((restante % 3600) / 60);
        var segundos = restante % 60;

        if (diasEl) diasEl.textContent = pad(dias);
        if (horasEl) horasEl.textContent = pad(horas);
        if (minutosEl) minutosEl.textContent = pad(minutos);
        if (segundosEl) segundosEl.textContent = pad(segundos);
      }

      el.dataset.caInitBannerPromoAnimado = 'true';
      tick();
      intervalosCuentaAtrasBannerPromoAnimado.set(el, setInterval(tick, 1000));
    });
  }

  function detenerCuentaAtrasBannerPromoAnimado(raiz) {
    var contenedores = (raiz || document).querySelectorAll(
      '[data-cuenta-atras-banner-promo-animado]'
    );

    contenedores.forEach(function (el) {
      var intervalo = intervalosCuentaAtrasBannerPromoAnimado.get(el);
      if (intervalo) {
        clearInterval(intervalo);
        intervalosCuentaAtrasBannerPromoAnimado.delete(el);
      }
    });
  }

  iniciarCuentaAtrasBannerPromoAnimado(document);

  document.addEventListener('shopify:section:load', function (evento) {
    iniciarCuentaAtrasBannerPromoAnimado(evento.target);
  });

  document.addEventListener('shopify:section:unload', function (evento) {
    detenerCuentaAtrasBannerPromoAnimado(evento.target);
  });
})();